<template>
  <el-card class="box-card role full-screen">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('idNumber')">
          <el-input v-model="queryForm.idPiece" size="small"></el-input>
        </el-form-item>

        <el-form-item :label="$t('country')">
          <el-select
            size="medium"
            v-model="queryForm.country"
            filterable
            :placeholder="$t('Please select country')"
            style="width: 100%"
          >
            <el-option
              v-for="item in countryList"
              :key="item.id"
              :label="$i18n.locale === 'fr' ? item.nameFr : item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isloading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>

      <el-row class="table-btns" type="flex" justify="space-between">
        <a @click="downloadEXCEL()" type="text" size="mini"
          ><i class="el-icon-download"></i> {{ $t("downloadEXCEL") }}</a
        >
      </el-row>
    </div>

    <div
      v-if="loginInfo.orgType == 1"
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
      :fit="false"
    >
      <el-table
        :data="tableData.records"
        v-loading="isloading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="selection"
          fixed="left"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="id"
          :label="$t('ID')"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="nomPrenom"
          :label="$t('name')"
          width="160"
        ></el-table-column>

        <el-table-column :label="$t('dateOfBirth')" width="160">
          <template slot-scope="scope">
            {{ formatDate(scope.row.dateNaissance) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="lieuNaissance"
          :label="$t('placeOfBirth')"
          width="160"
        >
        </el-table-column>
        <el-table-column :label="$t('country')">
          <template slot-scope="scope">
            {{ getCountryName(scope.row.country) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="idPiece"
          :label="$t('idNumber')"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="typePiece"
          :label="$t('idCardType')"
          width="160"
        ></el-table-column>
        <el-table-column prop="status" :label="$t('status')" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 3" class="text-primary">{{
              $t("PPE")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="dateAjout"
          :label="$t('creationTime')"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="createId"
          :label="$t('user')"
          width="160"
        ></el-table-column>
      </el-table>
    </div>

    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />
  </el-card>
</template>
<script>
import wantedPerson from "@/api/wantedPerson";
//import manba from "@/assets/uilt/manbaDate";
import { countries } from "@/assets/data/countries";
import qs from "qs";

export default {
  name: "transactionsPPE",
  data() {
    return {
      queryForm: {},
      addForm: {},
      checkForm: {},
      countryList: countries,
      rules: {
        name: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        nomPrenom: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        dateNaissance: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        lieuNaissance: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        idPiece: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        typePiece: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
      },
      //table高度，动态设置
      queryTableHeight: "",
      //table显示内容
      tableData: {},
      isCheckApply: false,

      pageSize: 20,
      currentPage: 1,

      //显示加载中
      isloading: false,
      //新增\编辑角色
      addRecordDrawer: false,
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    downloadUrl() {
      let _this = this;
      let param = JSON.parse(JSON.stringify(_this.queryForm));

      delete param.size;
      delete param.current;

      return (
        wantedPerson.wantedPersonDetailedExport + "?" + qs.stringify(param)
      );
    },
    displayCountries() {
      return countries
        .map((c) => ({
          id: c.id,
          name: this.$i18n.locale === "fr" ? c.nameFr : c.name, // ✅ Use this.$i18n.locale
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  watch: {},
  methods: {
    downloadEXCEL() {
      let download = document.createElement("a");
      download.href = this.downloadUrl;
      download.download = "";
      download.click();
    },
    getCountryName(countryCode) {
      if (!countryCode) return "-";

      const country = this.countryList.find((c) => c.id === countryCode);
      if (!country) return countryCode;

      // Return name based on current language
      return this.$i18n.locale === "fr" ? country.nameFr : country.name;
    },
    // ✅ Format date to YYYY-MM-DD
    formatDate(dateString) {
      if (!dateString) return "-";

      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    /**getWantedPersonsPage */
    getList() {
      let _this = this;
      wantedPerson.getPPEPage({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ..._this.queryForm,
        },
        success: (res) => {
          if (res.code == 200) _this.isloading = false;
          _this.tableData = res.data || {};
        },
      });
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
  mounted() {
    let _this = this;
    this.$nextTick(() => {
      let queryTableHeight = _this.$refs.pageHead.offsetHeight + 15;
      _this.queryTableHeight = queryTableHeight + "px";
      _this.getList();
    });
  },
};
</script>
<style lang="less" scoped>
.tree-card {
  height: 300px;
}
</style>
